var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandLess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0063A3",
  d: "M11.29 8.71 6.7 13.3a.997.997 0 0 0 1.41 1.41L12 10.83l3.88 3.88a.997.997 0 0 0 1.41-1.41L12.7 8.71a.996.996 0 0 0-1.41 0"
})));
export { SvgExpandLess as ReactComponent };